import type { SimpleCommuneAvecStatutAffectation } from "models";

/**
 * Retourne une couleur de Chip à partir du statut de sélection d'une commune
 */
export function getColorFrom(
  commune: SimpleCommuneAvecStatutAffectation
): "error" | "info" | undefined {
  switch (commune.statut) {
    case "affectation-supprimée":
      return "error";
    case "nouvelle-affectation":
      return "info";
    default:
      return undefined;
  }
}
